import actionTypes from "./actionTypes";
import api from "./api";
export default {
    getProject: (projectId) => ({
        type: actionTypes.GET_PROJECT,
        payload: {
            promise: () => api.getProject(projectId)
        },
        scope: `${actionTypes.GET_PROJECT}_${projectId}`
    }),
    getProjectSummaryReports: (projectId) => ({
        type: actionTypes.GET_PROJECT_SUMMARY_REPORTS,
        payload: {
            promise: () => api.getProjectSummaryReports(projectId)
        },
        meta: { projectId },
        scope: `${actionTypes.GET_PROJECT_SUMMARY_REPORTS}_${projectId}`
    }),
    setTab: (tab) => ({
        type: actionTypes.SET_TAB,
        tab
    })
};
